import React, {FC} from 'react';

import {StickyHeader} from '@/components/Layout';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import {twx} from '@/utils/tailwindUtils';

import LoginLanguageSelect from './LoginLanguageSelect';

interface LoginHeaderProps {
    title?: string;
    isLanguageSelectEnabled?: boolean;
}

const LoginHeader: FC<LoginHeaderProps> = ({title, isLanguageSelectEnabled}) => {
    const isDesktopLayout = useIsDesktopLayout();

    useDocumentTitle(title);

    return (
        <div className={twx('mt-safe-offset-sticky-header mb-8 flex w-full flex-col gap-6 ml:mb-6 ml:mt-0')}>
            {isDesktopLayout ? (
                <div className='flex w-full items-center justify-end'>
                    {isLanguageSelectEnabled && <LoginLanguageSelect />}
                </div>
            ) : (
                /* @ts-ignore */
                <StickyHeader title={title} endIcon={isLanguageSelectEnabled && <LoginLanguageSelect />} />
            )}
            {title && <h1 className='m-0 w-full p-0 text-28 font-bold leading-[40px]'>{title}</h1>}
        </div>
    );
};

export default LoginHeader;
